import { map } from "lodash";
import { columnNameAliases, notRequired as pharmacyNotRequired } from "../Schemas/PharmacyClaim";
import {
  columnNameAliases as medicalColumnNameAliases,
  notRequired as medicalNotRequired,
} from "../Schemas/MedicalClaim";
import {
  columnNameAliases as pharmacyEncounterColumnNameAliases,
  notRequired as pharmacyEncounterNotRequired,
} from "../Schemas/PharmacyEncounterClaim";
import {
  columnNameAliases as medicalEncounterColumnNameAliases,
  notRequired as medicalEncounterNotRequired,
} from "../Schemas/MedicalEncounterClaim";

export default class MappingValidations {
  static isValidColumnMapping(column, mappingName, notRequired) {
    const aliases = {
      ...columnNameAliases,
      ...medicalColumnNameAliases,
      ...pharmacyEncounterColumnNameAliases,
      ...medicalEncounterColumnNameAliases,
    };
    const getColumn = aliases[column];

    if (!getColumn) {
      return true;
    }

    if (notRequired?.includes(column) && !mappingName) {
      return true;
    }

    if (!mappingName) {
      return false;
    }

    const cleanNames = map(getColumn, (name) => name.toLowerCase().replace(/[\s_]/g, ""));
    const cleanMappingName = mappingName.toLowerCase().replace(/[\s_]/g, "");

    return cleanNames.includes(cleanMappingName);
  }

  static isValidPharmacyColumnMapping(column, mappingName) {
    return this.isValidColumnMapping(column, mappingName, pharmacyNotRequired);
  }

  static isValidMedicalColumnMapping(column, mappingName) {
    return this.isValidColumnMapping(column, mappingName, medicalNotRequired);
  }

  static isValidPharmacyEncounterColumnMapping(column, mappingName) {
    return this.isValidColumnMapping(column, mappingName, pharmacyEncounterNotRequired);
  }

  static isValidMedicalEncounterColumnMapping(column, mappingName) {
    return this.isValidColumnMapping(column, mappingName, medicalEncounterNotRequired);
  }
}
